import React from 'react'
import { Avatar } from '@material-ui/core'

export default function index({name, uid, about, imageUrl, fullDetails, searchWord, setSearchWord, setNewSelectedMembers, newSelectedMembers, allUsersInDatabase, setAllUsersInDatabase}) {
  return (
    <div className="single__contact" onClick={()=> {
        setNewSelectedMembers([...newSelectedMembers, fullDetails]);
        searchWord && setSearchWord('')
        let remainingFriends = allUsersInDatabase.filter(person => person.uid !== uid);
        setAllUsersInDatabase(remainingFriends)
      }
    }>
      <Avatar className="contact__avatar" src={imageUrl} />
      <div className="contact__info">
        <h3>{name}</h3>
        <p>{about}</p>
      </div>
    </div>
  )
}
